module.exports = __webpack_public_path__ + "img/w4-b3.6e8a5dd2.jpg";